'use client';

import { Minus, Plus } from 'lucide-react';

interface QuantitySelectorProps {
  quantity: number;
  maxQuantity?: number;
  onQuantityChange: (quantity: number) => void;
}

export default function QuantitySelector({ quantity, maxQuantity, onQuantityChange }: QuantitySelectorProps) {
  const isMaxReached = maxQuantity !== undefined ? quantity >= maxQuantity : false;

  return (
    <section className="px-5 py-5">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <span className="text-base font-semibold text-gray-900">수량</span>
          {maxQuantity !== undefined && (
            <span className="text-sm text-gray-500 mt-1">최대 {maxQuantity}개까지 주문 가능</span>
          )}
        </div>

        <div className="flex items-center gap-3">
          {/* 감소 버튼 */}
          <button
            className="w-[26px] h-[26px] flex items-center justify-center bg-gray-200 rounded-lg disabled:bg-[#F8F8F8]"
            onClick={() => onQuantityChange(quantity - 1)}
            disabled={quantity <= 1}
          >
            <Minus className="w-4 h-4 text-gray-900" />
          </button>

          {/* 수량 표시 */}
          <span className="text-base font-semibold text-gray-900 min-w-[20px] text-center">{quantity}</span>

          {/* 증가 버튼 */}
          <button
            className="w-[26px] h-[26px] flex items-center justify-center bg-gray-200 rounded-lg disabled:bg-[#F8F8F8]"
            onClick={() => onQuantityChange(quantity + 1)}
            disabled={isMaxReached}
          >
            <Plus className="w-4 h-4 text-gray-900" />
          </button>
        </div>
      </div>
    </section>
  );
}
